export default __webpack_public_path__ + "static/Poppins-SemiBold-64aed377be36e822042b92784f6f7de4.woff2";